import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const fetchSingleWorkOrder = ({commit, dispatch}, payload) => {

    let response = null
    commit('toggleLoadingState', true)
    axios.post('/workOrder/fetchSingleWorkOrder.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        console.log(JSON.stringify(res.data))
        response = res.data.response

        if(payload.download_request) {
            response.forEach(element => {
                element.id = 0
                element.sale_item_id = payload.sale_item_id_copy
                element.sale_item_sub_id = payload.sale_item_sub_id_copy
            })
            commit('displaySuccessNotification', {message: 'Data downloaded successfully!!!'});
        }
        
        commit('setSingleWorkOrderData', {response: response, wo_index: payload.wo_index, shortcut: payload.shortcut})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        setTimeout(() => {
            console.log(JSON.stringify(response))
            if(payload.work_order_id === 0) {
                dispatch('lazyLoadWorkOrderMeasurements', response)    
            } else {
                commit('toggleLoadingState', false)
            }
        }, 1000);
    })
    
}

export const fetchWorkOrderAutocompleteList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/workOrder/fetchWorkOrderAutocompleteList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        let response = []

        if(res.data.response.production) {
            res.data.response.production.forEach(element => {
                element.source = 'production'
                response.push(element)
            })
        }
        
        if(res.data.response.customer) {
            res.data.response.customer.forEach(element => {
                element.source = 'customer'
                response.push(element)
            })
        }
        
        commit('setWorkOrderAutocompleteList', response)
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-Work-Order'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const submitWorkOrderData = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.sale_item_index>=0) {
        commit('setWOProcessing', {index: payload.sale_item_index, status: true})
    }
    setTimeout(() => {
        commit('displaySuccessNotification', {message: 'Work-Order submitted successfully!!!'});  
        if(!payload.shortcut) {          
            commit('toggleLoadingState', false)
        }
    }, 2000);
    axios.post('/workOrder/submitWorkOrder.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {     
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            if(payload.sale_item_index>=0) {
                commit('setWOProcessing', {work_order_id: res.data.work_order_id, index: payload.sale_item_index, status: false})
            }
            if(payload.shortcut) {
                dispatch('fetchSingleWorkOrder', {shortcut: payload.shortcut, work_order_id: payload.work_order_list[0].id, sale_item_id: payload.work_order_list[0].sale_item_id, 
                    tailoring_item_id: payload.work_order_list[0].tailoring_item_id, customer_id: payload.work_order_list[0].customer_id})
            }          
            //
            if(payload.sale_id) {
                //dispatch('fetchSaleMasterData', {id: payload.sale_id})
            }
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        if(!payload.shortcut) {
            commit('toggleLoadingState', false)
        }
        
    })
}

export const lazyLoadWorkOrderMeasurements = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    //console.log(JSON.stringify(payload))
    payload.forEach(element => {
        axios.post('/workOrder/lazyLoad/index.php', {workOrderData: element, activeTab: '2'}, accessTokenInfo.accessTokenInfo())
        .then(res => {
            //return
            commit('setLazyLoadWorkOrder', 
                {
                    response: res.data.response, 
                    previousPayload: element,
                    activeTab: '2',
                    tailoring_item_id: element.tailoring_item_id 
                }
            )        
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error-Work-Order'})
        })
        .finally( () => {
            
        })
    })
    
    commit('toggleLoadingState', false)

}

export const lazyLoadWorkOrderSections = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/workOrder/lazyLoad/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        //console.log(JSON.stringify(res.data))
        //return
        commit('setLazyLoadWorkOrder', 
            {
                response: res.data.response, 
                previousPayload: payload.workOrderData,
                activeTab: payload.activeTab
            }
        )        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-Work-Order'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}


// WEBPACK FOOTER //
// ./src/store/modules/workOrder/actions.js